var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "../../node_modules/tsup/assets/esm_shims.js"() {
  }
});

// src/checkToken.ts
init_esm_shims();
function checkToken(token) {
  if (token !== void 0) {
    const errors = {};
    ["userAvatarUrl", "widgetKey", "userJWT", "userHMAC", "userPaseto"].forEach(
      (x) => typeof token[x] !== "string" && typeof token[x] !== "undefined" && token[x] !== null && (errors[x] = "should be string or undefined or null")
    );
    const isString = (x) => typeof token[x] !== "string" && (errors[x] = "should be string");
    ["widgetId"].forEach(isString);
    if (isUserToken(token)) {
      ["customerId", "customerName", "userId", "userEmail", "userName"].forEach(isString);
      if (!(token.userJWT || token.userHMAC || token.userPaseto || token.widgetKey)) {
        errors.userJWT = "userJWT or widgetKey should be set";
      }
    } else {
      ["widgetKey"].forEach(isString);
    }
    if (Object.keys(errors).length > 0) {
      return errors;
    }
  }
  return;
}
function isUserToken(token) {
  return token ? "userId" in token : false;
}

export {
  __commonJS,
  __toESM,
  init_esm_shims,
  checkToken,
  isUserToken
};
//# sourceMappingURL=chunk-C4UH2P2Q.js.map